export const error = {
  default: "Não foi possível completar a ação desejada!",
  invalid: "Este campo está inválido!",
  required: "Este campo é obrigatório!",
  not_equal: "Os campos devem ser iguais!",
  bad_requrest: "Erro ao carregar os dados {name}",
  min: "Mínimo de {min} caracteres!",
  unauthorized: "Não autorizado",
  file_not_supported: "Formato de arquivo não suportado",
};
